var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39777 5.66245L3.36027 0.946823C3.34449 0.934402 3.32553 0.926684 3.30557 0.924553C3.2856 0.922422 3.26544 0.925966 3.2474 0.934777C3.22936 0.943588 3.21417 0.95731 3.20357 0.974365C3.19298 0.991421 3.18741 1.01112 3.1875 1.0312V2.06647C3.1875 2.13209 3.2183 2.19504 3.2692 2.23522L8.09063 5.99995L3.2692 9.76468C3.21697 9.80486 3.1875 9.86781 3.1875 9.93343V10.9687C3.1875 11.0584 3.29063 11.108 3.36027 11.0531L9.39777 6.33745C9.44908 6.29742 9.4906 6.24622 9.51915 6.18773C9.5477 6.12925 9.56254 6.06503 9.56254 5.99995C9.56254 5.93487 9.5477 5.87064 9.51915 5.81216C9.4906 5.75368 9.44908 5.70248 9.39777 5.66245Z",
    fill: "#C6CBD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNext);
export default __webpack_public_path__ + "static/media/pageNext.200c36b9299fba0b21b61acda8d6a770.svg";
export { ForwardRef as ReactComponent };